import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("aigl_admin_token", data.token);
      localStorage.setItem("aigl_admin_email", data.email);
      toast.success("Welcome back, admin.");
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A192F] flex items-center justify-center p-5">
      <div className="absolute inset-0 hero-grid opacity-30" />
      <div className="relative w-full max-w-md bg-white border border-slate-200 p-10">
        <Link to="/" className="font-accent text-[10px] text-[#C5A059]">
          &larr; BACK TO SITE
        </Link>
        <div className="flex items-center gap-3 mt-6 mb-8">
          <div className="w-12 h-12 bg-[#0A192F] flex items-center justify-center">
            <Lock className="w-5 h-5 text-[#C5A059]" />
          </div>
          <div>
            <h1 className="font-display text-2xl text-[#0A192F]">Admin Sign In</h1>
            <p className="text-xs text-slate-500">AIGL Channel control panel</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-accent text-slate-500 mb-1.5 block">EMAIL</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:border-[#C5A059]"
            />
          </div>
          <div>
            <label className="text-xs font-accent text-slate-500 mb-1.5 block">PASSWORD</label>
            <input
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:border-[#C5A059]"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#C5A059] hover:bg-[#D4AF37] text-[#0A192F] font-bold py-3.5 text-sm transition flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "SIGN IN"}
          </button>
        </form>
      </div>
    </div>
  );
}
